<template>
  <div class="overlay">
    <div class="sub-tarefa-inputs">
      <div class="modal-header">
        <span class="modal-label">aviso</span>
        <h6 class="btn-fechar-modal" @click="fecharModal()">
          ×
        </h6>
      </div>

      <div class="sub-tarefa-all-inputs">
        <div class="btns">
          <div class="subTarefa-titulo-input subTarefa-titulo-input-aviso" v-if="sucesso == true">
            <i class="fa-solid fa-circle-check fa-3x" style="color: #27d41b"></i>
            <h4>{{ texto }}</h4>
          </div>

          <div class="subTarefa-titulo-input subTarefa-titulo-input-aviso" v-else>
            <i class="fa-sharp fa-solid fa-circle-exclamation fa-3x" style="color: var(--vermelho)"></i>
            <h4>{{ texto }}</h4>
          </div>
        </div>
        <div v-if="mostrarBotoesLogin" class="modal-botoes">
          <button class="btn-voltar" @click="fecharModal()">
            Voltar
          </button>

          <button class="btn-login" @click="irParaLogin()">
            Login
          </button>
        </div>

        <button v-else class="btn-ok" @click="fecharModal()">
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  sucesso: Boolean,
  texto: String,

  mostrarBotoesLogin: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["fecharModal", "login"]);

function fecharModal() {
  emit("fecharModal");
}

function irParaLogin() {
  emit("login");
}
</script>

<style scoped>
.sub-tarefa-inputs {
  border: none;
  border-radius: 12px;
  width: 430px;
  max-width: 90vw;
  box-shadow: 0 8px 24px hsla(0, 0%, 0%, 0.35);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sub-tarefa-inputs-top {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: var(--roxo-primario);
  padding: 12px 0;
  position: relative;
  min-height: 46px;
}

.sub-tarefa-inputs-top h6:first-child {
  color: var(--branco);
  font-weight: 700;
  font-size: 14px;
  margin: 0;
  text-align: center;
  letter-spacing: 0.5px;
}

.sub-tarefa-inputs-top h6:last-child {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 14px;
  background-color: var(--roxo-primario);
  color: var(--branco);
  margin: 0;
  cursor: pointer;
  font-weight: bold;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border-radius: 0 12px 0 0;
  min-width: 38px;
}

.sub-tarefa-inputs-top h6:last-child:hover {
  background-color: var(--roxo-primario);
}

.sub-tarefa-all-inputs {
  background-color: var(--branco);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.btns {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.subTarefa-titulo-input-aviso {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
}

.subTarefa-titulo-input-aviso h4 {
  font-size: 1rem;
  color: var(--preto);
  margin: 0;
  text-align: center;
  white-space: pre-line;
  word-break: break-word;
}

/* Botão OK original */
.btn-ok {
  background-color: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  padding: 9px 40px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.3px;
  transition: background-color 0.15s ease;
}

.btn-ok:hover {
  background-color: var(--roxo-medio);
}

/* Novos botões */
.modal-botoes {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.modal-botoes button {
  border: none;
  border-radius: 8px;
  padding: 9px 30px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.3px;
  transition: background-color 0.15s ease;
}

.btn-voltar {
  background-color: var(--cinza-claro);
  color: var(--cinza-escuro);
}

.btn-voltar:hover {
  background-color: var(--cinza-claro);
}

.btn-login {
  background-color: var(--roxo-claro);
  color: var(--branco);
}

.btn-login:hover {
  background-color: var(--roxo-medio);
}

.btn-login:hover {
  background-color: var(--roxo-medio);
}
</style>
